import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { BACKEND_URL } from '../utils/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/login');
          return;
        }

        const { data } = await axios.post(
          `${BACKEND_URL}/api/auth/google-callback`,
          { session_id: sessionId }
        );

        if (data.access_token) {
          // Persist Bearer token in localStorage + axios default header so
          // every subsequent request authenticates correctly in browsers
          // where cookies don't carry (WhatsApp WebView, Capacitor APK).
          try { localStorage.setItem('bliss_token', data.access_token); } catch (_) { /* storage blocked */ }
          axios.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
          sessionStorage.setItem('bliss_user', JSON.stringify({
            id: data.id,
            email: data.email,
            nickname: data.nickname,
            role: data.role,
            profile_picture: data.profile_picture,
          }));
        }

        navigate('/', { state: { user: data }, replace: true });
      } catch (error) {
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{background: '#000000'}}>
      <div className="text-center">
        <div className="w-16 h-16 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="font-['Outfit'] text-white/30">Completing sign in...</p>
      </div>
    </div>
  );
}
